module.exports = __webpack_public_path__ + "static/media/fiolka.3dc796fb.png";